import { State } from "../reducers";

export const fcListSelector = (state: State) => state.fcListReducer;
export const pgListSelector = (state: State) => state.pgListReducer;